import type { ClawPassType } from '@/app/types';

/**
 * 是否应先引导购买 Vidu 会员（PlanDetail 弹窗），而非直接进入 claw 权益包弹窗。
 *
 * 仅拦截「无任何 claw 权益、且买不了捆绑套餐的免费用户」——引导其先开通会员。
 * 已持有生效中 claw 权益的用户（userVariant === 'clawPass'，即「立即续购」场景）
 * 续购的是 claw_pass 本身，不应被引导去会员套餐弹窗。
 */
export const shouldOpenPlanDetailFirst = (
  subsPlan: string | undefined,
  clawPass: Pick<ClawPassType, 'can_purchase_claw_pass_bundle' | 'userVariant'> | null,
): boolean => {
  const isClawPassHolder = clawPass?.userVariant === 'clawPass';
  return subsPlan === 'free' && clawPass?.can_purchase_claw_pass_bundle !== true && !isClawPassHolder;
};
